import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

export const RatingFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds, isDisabled } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const handleChangeRatingType = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  const ratingTypes = [
    {
      id: 1,
      label: t('filter:star1'),
      testId: 'filter-star1-checkbox',
      labelTestId: 'filter-star1-label',
    },
    {
      id: 2,
      label: t('filter:star2'),
      testId: 'filter-star2-checkbox',
      labelTestId: 'filter-star2-label',
    },
    {
      id: 3,
      label: t('filter:star3'),
      testId: 'filter-star3-checkbox',
      labelTestId: 'filter-star3-label',
    },
    {
      id: 4,
      label: t('filter:star4'),
      testId: 'filter-star4-checkbox',
      labelTestId: 'filter-star4-label',
    },
    {
      id: 5,
      label: t('filter:star5'),
      testId: 'filter-star5-checkbox',
      labelTestId: 'filter-star5-label',
    },
  ];

  return (
    <div className={classNames('grid', className)}>
      {ratingTypes.map(({ id, label, testId, labelTestId }) => (
        <UiFormControlLabel
          key={id}
          className='mr-0'
          label={label}
          data-testid={labelTestId}
          control={
            <UiCheckbox
              checked={selectedIds?.includes(id)}
              name={id}
              inputProps={{ 'data-testid': testId }}
              onChange={(event) => handleChangeRatingType(event, id)}
              disabled={isDisabled}
            />
          }
        />
      ))}
    </div>
  );
};

RatingFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
